import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { statConstants, statModels } from '..';

export const useStatCallHistoryTags = (
  props: {
    callType?: string | null;
    startDate?: number;
    finishDate?: number;
    employeeId?: number[] | null | undefined;
    pipeId?: number | null;
    statuses?: string[];
    durationStart?: number | null;
    durationFinish?: number | null;
    talkTimeStart?: number | null;
    talkTimeFinish?: number | null;
  } = {}
) =>
  useQuery<statModels.ICallHistoryTags>({
    queryKey: [statConstants.queryKeys.STAT_CALL_HISTORY_TAGS, props],
    queryFn: async () => {
      const res = await $api.post('/v1/stat/call-history/tags', { ...props });

      return res?.data?.data;
    }
  });
